import React, { useCallback, useEffect, useState, useRef } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import Pagination from "../../../../../../ui/Pagination";
import NoDataFound from "../../../../../../ui/NoDataFound";
import ContentBox from "../../../../../../ui/ContentBox";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

import { plusIcon, minusIcon } from "../../../../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getIpAddressPortInfo } from "../../../../../../../store/actions/scanInfoAction";

const PortInformation = ({selectedIpDetails, domainId, scanId}) => {

    const ipAddressPortInfoList = useSelector((state) => state?.scanInfo.ipAddressPortList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef= useRef(null)

    const dispatch = useDispatch();

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [selecetedPortInfo, setSelectedPortInfo] = useState('');

    const selectPortInfo = (data) => {
        if(selecetedPortInfo === data) {
            setSelectedPortInfo("")
        } else {
            setSelectedPortInfo(data)
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchIpAddressPortInfoList = useCallback(()=>{
        setIsLoading(true)
        let url = `&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedIpDetails?.domain}&scan_id=${selectedIpDetails?.scan_id}&ip_address=${selectedIpDetails?.ip_address}`
        dispatch(getIpAddressPortInfo(url))

    },[dispatch, currentPage, currentPageSize, selectedIpDetails])

    useEffect(()=>{
        if(selectedIpDetails || domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
                fetchIpAddressPortInfoList();
                prevDomainIdRef.current = domainId;
                prevScanIdRef.current = scanId
        }
    },[domainId, scanId, fetchIpAddressPortInfoList, selectedIpDetails]);

    useEffect(()=>{
        if(ipAddressPortInfoList !== null) {
            setIsLoading(false)
        }
    },[ipAddressPortInfoList])

    return (
        <>
            {
                isLoading ? 
                <SkeletonLoader type={"line"} count={3} currentPage={"ipAddress"} />
                :
                ipAddressPortInfoList !== null && ipAddressPortInfoList?.results.length > 0 &&
                ipAddressPortInfoList?.results.map((data, index) => {
                    return (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <div className="port-information-container mb-3">
                                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{selectPortInfo(data?.port)}}>
                                    <h2 className="heading">Port: {data?.port}</h2>
                                    <div className="port-tag-container">
                                        {data?.malware?.is_malware && <span className="tag-content expired">Infected</span>}
                                        {data?.compromised?.is_compromised && <span className="tag-content expired">Compromised</span>}
                                        {data?.risky_port && <span className="tag-content expired">Risky Port</span>}
                                        {selecetedPortInfo === data?.port ? minusIcon() : plusIcon()}
                                    </div>                                               
                                </div>
                                {selecetedPortInfo === data?.port && <div className="tab-details-container p-2">
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <Row>                                   
                                            <Col lg={3}>
                                                <ContentBox label={"Transport"} value={data?.transport} />
                                            </Col>
                                            <Col lg={3}>
                                                <ContentBox label={"Service"} value={data?.service} />
                                            </Col>
                                            <Col lg={3}>
                                                <ContentBox label={"Product"} value={data?.product} />
                                            </Col>
                                            <Col lg={3}>
                                                <ContentBox label={"Product Version"} value={data?.version} />
                                            </Col>
                                        </Row>
                                    </motion.div>
                                </div>}
                            </div>
                        </motion.div>
                    )
                })
            }
            {
                !isLoading && ipAddressPortInfoList !== null && ipAddressPortInfoList?.results.length === 0 && 
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <NoDataFound noDataText={"No Record Found"}/>
                </motion.div>
            }
            {ipAddressPortInfoList !== "" && ipAddressPortInfoList?.results.length > 0 && <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                pageSize={currentPageSize}
                totalCount={ipAddressPortInfoList?.meta?.total_results}
                onPageChange={setCurrentPageandRecordSize}
            />}
            
        </>
    )
}

export default PortInformation